import type { AnalyticsFeature } from "@/lib/analytics/events";

export type AnalyticsClickProps = {
  /**
   * Required for auto-click tracking. Typically use a stable id like:
   * - "pay_now_button"
   * - "start_capture_button"
   */
  event: string;
  elementId?: string;
  label?: string;
  feature?: AnalyticsFeature;
  location?: string;
  value?: number;
};

/**
 * Helper for adding consistent data attributes that `installAutoClickTracking()` can pick up.
 *
 * Usage:
 *   <Button {...analyticsClick({ event: "start_capture_button", feature: "camera" })} />
 */
export function analyticsClick(input: AnalyticsClickProps): Record<string, string> {
  const out: Record<string, string> = {
    "data-analytics-event": input.event,
  };

  if (input.elementId) out["data-analytics-element-id"] = input.elementId;
  if (input.label) out["data-analytics-label"] = input.label;
  if (input.feature) out["data-analytics-feature"] = input.feature;
  if (input.location) out["data-analytics-location"] = input.location;
  if (input.value != null) out["data-analytics-value"] = String(input.value);

  return out;
}


